import { getEcState, useCookies } from '@packages/utilities';
import useSWR from 'swr';
import { useRouter } from 'next/router';
import { getMainAudience } from '@packages/cms-components';
import type { PromotionVariantsData } from '../types';
import { promotionBannerDataFetcher } from './promotionBannerDataFetcher';

export const usePromotionBannerData = (
  fallbackPromotionData: PromotionVariantsData | undefined = undefined,
) => {
  const { locale: language, defaultLocale: defaultLanguage, query } = useRouter();
  const { getCookies } = useCookies();
  const finalLanguage = language || defaultLanguage || 'de';
  const audience = getMainAudience(getEcState(getCookies()));
  const promotionBannerCacheKey = `promotionBannerData-${finalLanguage}-${audience}`;
  const { data, isLoading } = useSWR<PromotionVariantsData>(
    promotionBannerCacheKey,
    () => promotionBannerDataFetcher(query, getCookies(), undefined, finalLanguage, true),
    {
      fallbackData: fallbackPromotionData,
      revalidateIfStale: false,
      // INSPIRE-3409 - do not revalidate on focus to apply correct data when getting back to the shop-browser-tab
      revalidateOnFocus: false,
    },
  );
  return {
    data,
    isLoading,
    endpoint: promotionBannerCacheKey,
    hasExpiredData: [data?.active, data?.selected].some((promoData) => promoData?.isExpired),
  };
};
